const GET_FORM_VALUES = 'publicadorProf/featuresStep/GET_FORM_VALUES';
const UDPATE_FORMVALUES = 'publicadorProf/featuresStep/UDPATE_FORMVALUES';
const UPDATE_UNIT_MEASUREMENT = 'publicadorProf/featuresStep/UPDATE_UNIT_MEASUREMENT';
const SET_ANTIQUITY_TYPE = 'publicadorProf/featuresStep/SET_ANTIQUITY_TYPE';

const RESET_INFO = 'publicador/ducks/featuresStep/RESET_INFO';

export { GET_FORM_VALUES, UDPATE_FORMVALUES, UPDATE_UNIT_MEASUREMENT, SET_ANTIQUITY_TYPE, RESET_INFO };
